export default __webpack_public_path__ + "static/media/penarikan-komisi.8cdd8a3a.png";